(function () {
  'use strict';

  function getBundleGroupId(item) {
    if (!item.properties) return null;
    return item.properties._bundle_group || null;
  }

  function isBundlePrimary(item) {
    return item.properties && item.properties._bundle_primary === 'true';
  }

  function isBundleComponent(item) {
    return item.properties && item.properties._bundle_component === 'true';
  }

  function partitionCartItems(items) {
    var bundlesMap = {};
    var bundleOrder = [];
    var standalone = [];

    items.forEach(function (item) {
      var groupId = getBundleGroupId(item);
      if (groupId) {
        if (!bundlesMap[groupId]) {
          bundlesMap[groupId] = {
            groupId: groupId,
            items: [],
            title: item.properties.Bundle || '',
            flavors: item.properties.Flavors || '',
            freeGifts: item.properties['Free gifts'] || '',
            sellingPlanName: item.selling_plan_allocation
              ? item.selling_plan_allocation.selling_plan.name
              : '',
            image: item.image,
            total: 0,
            keys: [],
            giftItems: [],
            hasPrimary: false,
          };
          bundleOrder.push(groupId);
        }
        var bundle = bundlesMap[groupId];
        bundle.items.push(item);
        bundle.keys.push(item.key);
        if (item.properties._bundle_gift === 'true') {
          bundle.giftItems.push(item);
        }
        if (isBundlePrimary(item)) {
          bundle.hasPrimary = true;
          bundle.total = item.final_line_price;
          if (item.image) bundle.image = item.image;
          if (item.properties['Free gifts']) bundle.freeGifts = item.properties['Free gifts'];
          if (item.selling_plan_allocation) {
            bundle.sellingPlanName = item.selling_plan_allocation.selling_plan.name;
          }
        } else if (!bundle.hasPrimary && !isBundleComponent(item)) {
          bundle.total += item.final_line_price;
        }
        if (!bundle.title && item.properties.Bundle) bundle.title = item.properties.Bundle;
        if (!bundle.flavors && item.properties.Flavors) bundle.flavors = item.properties.Flavors;
        if (!bundle.freeGifts && item.properties['Free gifts']) {
          bundle.freeGifts = item.properties['Free gifts'];
        }
        if (!bundle.sellingPlanName && item.selling_plan_allocation) {
          bundle.sellingPlanName = item.selling_plan_allocation.selling_plan.name;
        }
        if (!bundle.image && item.image && !isBundleComponent(item)) bundle.image = item.image;
      } else {
        standalone.push(item);
      }
    });

    return {
      bundles: bundleOrder.map(function (id) {
        return bundlesMap[id];
      }),
      standalone: standalone,
    };
  }

  function getAdjustedCartTotal(cart) {
    return cart.total_price;
  }

  function getDisplayItemCount(items) {
    var partitioned = partitionCartItems(items);
    return partitioned.bundles.length + partitioned.standalone.length;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderCartItemsHtml(cart) {
    var partitioned = partitionCartItems(cart.items);
    var html = '<ul class="cart-drawer__items">';

    partitioned.bundles.forEach(function (bundle) {
      var title = bundle.title || 'Bundle';
      html += '<li class="cart-drawer__item cart-drawer__item--bundle" data-bundle-group="' + escapeHtml(bundle.groupId) + '">';
      if (bundle.image) {
        html +=
          '<div class="cart-drawer__item-image"><img src="' +
          escapeHtml(bundle.image) +
          '" alt="" width="72" height="72"></div>';
      }
      html += '<div class="cart-drawer__item-details">';
      html += '<span class="cart-drawer__item-title">' + escapeHtml(title) + '</span>';
      if (bundle.flavors) {
        html += '<p class="cart-drawer__item-variant">' + escapeHtml(bundle.flavors) + '</p>';
      }
      if (bundle.sellingPlanName) {
        html +=
          '<p class="cart-drawer__item-plan">' + escapeHtml(bundle.sellingPlanName) + '</p>';
      }
      if (bundle.freeGifts) {
        html +=
          '<p class="cart-drawer__item-plan">Free gifts: ' + escapeHtml(bundle.freeGifts) + '</p>';
      }
      bundle.giftItems.forEach(function (gift) {
        html += '<div class="cart-drawer__bundle-gift">';
        if (gift.image) {
          html +=
            '<div class="cart-drawer__bundle-gift-image"><img src="' +
            escapeHtml(gift.image) +
            '" alt="" width="48" height="48"></div>';
        }
        html += '<div class="cart-drawer__bundle-gift-details">';
        html +=
          '<span class="cart-drawer__bundle-gift-title">' +
          escapeHtml(gift.product_title) +
          '</span>';
        html += '<span class="cart-drawer__bundle-gift-note">First subscription order only</span>';
        html += '</div>';
        html +=
          '<span class="cart-drawer__bundle-gift-price' +
          (gift.final_line_price === 0 ? ' is-free' : '') +
          '">' +
          (gift.final_line_price === 0 ? 'FREE' : formatMoney(gift.final_line_price)) +
          '</span>';
        html += '</div>';
      });
      html += '<div class="cart-drawer__item-bottom">';
      html +=
        '<button type="button" class="cart-drawer__remove-bundle js-cart-bundle-remove" data-line-keys="' +
        escapeHtml(bundle.keys.join(',')) +
        '">Remove bundle</button>';
      html += '<span class="cart-drawer__item-price">' + formatMoney(bundle.total) + '</span>';
      html += '</div></div></li>';
    });

    partitioned.standalone.forEach(function (item) {
      html += '<li class="cart-drawer__item" data-line-key="' + escapeHtml(item.key) + '">';
      if (item.image) {
        html +=
          '<a href="' +
          escapeHtml(item.url) +
          '" class="cart-drawer__item-image"><img src="' +
          escapeHtml(item.image) +
          '" alt="" width="72" height="72"></a>';
      }
      html += '<div class="cart-drawer__item-details">';
      html +=
        '<a href="' +
        escapeHtml(item.url) +
        '" class="cart-drawer__item-title">' +
        escapeHtml(item.product_title) +
        '</a>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>';
      }
      if (item.selling_plan_allocation) {
        html +=
          '<p class="cart-drawer__item-plan">' +
          escapeHtml(item.selling_plan_allocation.selling_plan.name) +
          '</p>';
      }
      html += '<div class="cart-drawer__item-bottom">';
      html += '<div class="cart-drawer__qty">';
      html +=
        '<button type="button" class="cart-drawer__qty-btn js-cart-qty" data-action="minus" data-line-key="' +
        escapeHtml(item.key) +
        '">−</button>';
      html += '<span class="cart-drawer__qty-value">' + item.quantity + '</span>';
      html +=
        '<button type="button" class="cart-drawer__qty-btn js-cart-qty" data-action="plus" data-line-key="' +
        escapeHtml(item.key) +
        '">+</button>';
      html += '</div>';
      html += '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>';
      html += '</div></div></li>';
    });

    html += '</ul>';
    return html;
  }

  var cartDrawer = document.querySelector('.js-cart-drawer');
  var cartDrawerBody = document.querySelector('.js-cart-drawer-body');
  var cartDrawerFooter = document.querySelector('.js-cart-drawer-footer');
  var cartCountEls = document.querySelectorAll('.js-cart-count');
  var cartSubtotalEl = document.querySelector('.js-cart-subtotal');

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount(cart) {
    var count = getDisplayItemCount(cart.items || []);
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count <= 0;
    });
  }

  function isRechargeCartActive() {
    return Boolean(window.RechargeStorefrontConfig);
  }

  function openRechargeCartDrawer() {
    if (window.RechargePubSub && typeof window.RechargePubSub.publish === 'function') {
      window.RechargePubSub.publish('cart-drawer:open');
      return Promise.resolve();
    }

    return Promise.resolve();
  }

  function openCart() {
    if (isRechargeCartActive()) {
      return openRechargeCartDrawer();
    }

    openCartDrawer();
    return Promise.resolve();
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('.js-cart-drawer-toggle').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.querySelectorAll('.js-cart-drawer-toggle').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function renderCartDrawer(cart) {
    updateCartCount(cart);

    if (cartSubtotalEl) {
      cartSubtotalEl.textContent = formatMoney(getAdjustedCartTotal(cart));
    }

    if (!cartDrawerBody) return;

    if (cart.item_count === 0) {
      cartDrawerBody.innerHTML =
        '<p class="cart-drawer__empty">Your cart is empty.</p>' +
        '<a href="/collections/all" class="mua-btn mua-btn--primary">Continue shopping</a>';
      if (cartDrawerFooter) cartDrawerFooter.hidden = true;
      return;
    }

    if (cartDrawerFooter) cartDrawerFooter.hidden = false;
    cartDrawerBody.innerHTML = renderCartItemsHtml(cart);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      return res.json();
    });
  }

  function changeLineItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (res) {
      return res.json();
    });
  }

  function parseSubscriptionGiftPlan(item) {
    if (!item.properties || !item.properties._subscription_gift_plan) return [];
    try {
      var plan = JSON.parse(item.properties._subscription_gift_plan);
      if (!Array.isArray(plan)) return [];
      return plan.filter(function (gift) {
        return gift && gift.variantId && (parseInt(gift.quantity, 10) || 0) > 0;
      });
    } catch (_error) {
      return [];
    }
  }

  function subscriptionGiftCartChanges(cart, allowAddMissing) {
    var qualifyingGroups = {};
    var giftItemsByGroup = {};
    var updates = {};
    var additions = [];

    (cart.items || []).forEach(function (item) {
      var properties = item.properties || {};
      var groupId = properties._bundle_group;
      if (!groupId) return;

      if (properties._bundle_primary === 'true' && item.selling_plan_allocation) {
        qualifyingGroups[groupId] = {
          quantity: item.quantity,
          gifts: parseSubscriptionGiftPlan(item),
        };
      }

      if (properties._bundle_gift === 'true') {
        if (!giftItemsByGroup[groupId]) giftItemsByGroup[groupId] = [];
        giftItemsByGroup[groupId].push(item);
      }
    });

    Object.keys(giftItemsByGroup).forEach(function (groupId) {
      var group = qualifyingGroups[groupId];
      giftItemsByGroup[groupId].forEach(function (giftItem) {
        if (!group) {
          updates[giftItem.key] = 0;
          return;
        }

        var plannedGift = group.gifts.find(function (gift) {
          return parseInt(gift.variantId, 10) === giftItem.variant_id;
        });
        if (!plannedGift) {
          updates[giftItem.key] = 0;
          return;
        }

        var expectedQuantity = group.quantity * (parseInt(plannedGift.quantity, 10) || 1);
        if (giftItem.quantity !== expectedQuantity) {
          updates[giftItem.key] = expectedQuantity;
        }
      });
    });

    if (allowAddMissing) {
      Object.keys(qualifyingGroups).forEach(function (groupId) {
        var group = qualifyingGroups[groupId];
        var existingGifts = giftItemsByGroup[groupId] || [];
        group.gifts.forEach(function (plannedGift) {
          var variantId = parseInt(plannedGift.variantId, 10);
          var exists = existingGifts.some(function (giftItem) {
            return giftItem.variant_id === variantId;
          });
          if (exists || !variantId) return;

          additions.push({
            id: variantId,
            quantity: group.quantity * (parseInt(plannedGift.quantity, 10) || 1),
            properties: {
              _bundle_group: groupId,
              _bundle_component: 'true',
              _bundle_gift: 'true',
              _first_subscription_gift: 'true',
            },
          });
        });
      });
    }

    return { updates: updates, additions: additions };
  }

  function reconcileSubscriptionGifts(options) {
    options = options || {};
    return fetchCart()
      .then(function (cart) {
        var changes = subscriptionGiftCartChanges(cart, Boolean(options.allowAddMissing));
        var updateKeys = Object.keys(changes.updates);
        var chain = Promise.resolve(cart);

        if (updateKeys.length) {
          chain = chain.then(function () {
            return fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: changes.updates }),
            }).then(function (res) {
              if (!res.ok) throw new Error('Could not update subscription gifts.');
              return res.json();
            });
          });
        }

        if (changes.additions.length) {
          chain = chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: changes.additions }),
            }).then(function (res) {
              if (!res.ok) throw new Error('Could not add subscription gifts.');
              return fetchCart();
            });
          });
        }

        return chain.then(function (updatedCart) {
          return {
            cart: updatedCart,
            changed: updateKeys.length > 0 || changes.additions.length > 0,
          };
        });
      })
      .then(function (result) {
        updateCartCount(result.cart);
        if (result.changed && options.reloadOnChange) {
          window.location.reload();
        }
        return result;
      });
  }

  function initRechargeSubscriptionGiftGuard() {
    if (!window.MutationObserver || !window.WeakSet) return;

    var guardedRoots = new WeakSet();
    var reconciliationTimer = null;
    var checkoutGuardBypass = false;

    function scheduleReconciliation(allowAddMissing) {
      window.clearTimeout(reconciliationTimer);
      reconciliationTimer = window.setTimeout(function () {
        reconcileSubscriptionGifts({
          allowAddMissing: allowAddMissing,
          reloadOnChange: true,
        }).catch(function () {});
      }, 700);
    }

    function guardShadowRoot(root) {
      if (!root || guardedRoots.has(root)) return;
      guardedRoots.add(root);

      root.addEventListener(
        'click',
        function (event) {
          if (!root.querySelector('#CartSheet')) return;
          var button = event.target && event.target.closest
            ? event.target.closest('button')
            : null;
          if (!button) return;
          var label = (button.textContent || '').trim();

          if (/^Checkout$/i.test(label) && !checkoutGuardBypass) {
            event.preventDefault();
            event.stopImmediatePropagation();
            window.clearTimeout(reconciliationTimer);
            reconcileSubscriptionGifts({ allowAddMissing: true })
              .then(function () {
                checkoutGuardBypass = true;
                button.click();
                window.setTimeout(function () {
                  checkoutGuardBypass = false;
                }, 0);
              })
              .catch(function () {
                checkoutGuardBypass = false;
              });
            return;
          }

          if (/^(Remove|Increase quantity|Decrease quantity)/i.test(label)) {
            scheduleReconciliation(false);
            return;
          }

          if (/^Upgrade to subscription/i.test(label)) {
            scheduleReconciliation(true);
          }
        },
        true
      );

      root.addEventListener(
        'change',
        function () {
          if (root.querySelector('#CartSheet')) scheduleReconciliation(true);
        },
        true
      );
    }

    function inspectNode(node) {
      if (!node || node.nodeType !== 1) return;
      if (node.shadowRoot) guardShadowRoot(node.shadowRoot);
      if (!node.querySelectorAll) return;
      node.querySelectorAll('*').forEach(function (element) {
        if (element.shadowRoot) guardShadowRoot(element.shadowRoot);
      });
    }

    inspectNode(document.documentElement);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(inspectNode);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    reconcileSubscriptionGifts({ reloadOnChange: true }).catch(function () {});
  }

  function removeBundleLineItems(keys) {
    var chain = Promise.resolve();
    keys.forEach(function (key) {
      if (!key) return;
      chain = chain.then(function () {
        return changeLineItem(key, 0);
      });
    });
    return chain.then(fetchCart);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.js-cart-drawer-toggle');
    if (toggle) {
      event.preventDefault();

      if (isRechargeCartActive()) {
        fetchCart().then(renderCartDrawer).then(openCart);
        return;
      }

      if (cartDrawer && cartDrawer.classList.contains('is-open')) {
        closeCartDrawer();
      } else {
        fetchCart().then(renderCartDrawer).then(openCartDrawer);
      }
      return;
    }

    if (event.target.closest('.js-cart-drawer-close')) {
      closeCartDrawer();
      return;
    }

    var removeBundleBtn = event.target.closest('.js-cart-bundle-remove');
    if (removeBundleBtn) {
      var lineKeys = (removeBundleBtn.getAttribute('data-line-keys') || '')
        .split(',')
        .filter(Boolean);
      removeBundleLineItems(lineKeys).then(renderCartDrawer);
      return;
    }

    var qtyBtn = event.target.closest('.js-cart-qty');
    if (qtyBtn) {
      var lineKey = qtyBtn.getAttribute('data-line-key');
      var action = qtyBtn.getAttribute('data-action');
      var qtyEl = qtyBtn.parentElement.querySelector('.cart-drawer__qty-value');
      var currentQty = parseInt(qtyEl.textContent, 10) || 1;
      var nextQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);
      changeLineItem(lineKey, nextQty).then(renderCartDrawer);
      return;
    }

    var mobileToggle = event.target.closest('.js-mobile-nav-toggle');
    if (mobileToggle) {
      var nav = document.querySelector('.js-mobile-nav');
      if (!nav) return;
      var expanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      nav.hidden = expanded;
      return;
    }

    var faqBtn = event.target.closest('.js-faq-toggle');
    if (faqBtn) {
      var answer = faqBtn.nextElementSibling;
      var isOpen = faqBtn.getAttribute('aria-expanded') === 'true';
      faqBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (answer) answer.hidden = isOpen;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCartDrawer();
  });

  function initProductForm() {
    var form = document.querySelector('.js-product-form');
    if (!form) return;

    var productJson = document.getElementById('ProductJSON');
    if (!productJson) return;

    var product = JSON.parse(productJson.textContent);
    var variantInput = form.querySelector('[name="id"]');
    var sellingPlanInput = form.querySelector('.js-selling-plan-input');
    var submitBtn = form.querySelector('.js-product-submit');
    var mainImage = document.querySelector('.js-product-main-image');
    var optionButtons = form.querySelectorAll('.js-variant-option');

    function getSelectedOptions() {
      var options = [];
      product.options.forEach(function (_option, index) {
        var selected = form.querySelector('.js-variant-option.is-selected[data-option-index="' + index + '"]');
        // Fall back to the first variant's option value (not the option name)
        // so single-variant products still resolve to their default variant.
        options.push(selected ? selected.getAttribute('data-option-value') : product.variants[0].options[index]);
      });
      return options;
    }

    function findVariant() {
      var selected = getSelectedOptions();
      return product.variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selected[index];
        });
      });
    }

    function updateVariantUI() {
      var variant = findVariant();
      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Unavailable';
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (mainImage && variant.featured_image) {
        mainImage.src = variant.featured_image.src;
        mainImage.alt = variant.featured_image.alt || product.title;
      }

      var priceEl = document.querySelector('.js-product-price');
      if (priceEl) {
        priceEl.innerHTML = variant.available
          ? formatMoney(variant.price)
          : 'Sold out';
      }
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = button.getAttribute('data-option-index');
        form.querySelectorAll('.js-variant-option[data-option-index="' + index + '"]').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        button.classList.add('is-selected');
        updateVariantUI();
      });
    });

    form.querySelectorAll('.js-selling-plan-option').forEach(function (option) {
      option.addEventListener('click', function () {
        form.querySelectorAll('.js-selling-plan-option').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        option.classList.add('is-selected');
        var input = option.querySelector('input[type="radio"]');
        if (input) input.checked = true;
        if (sellingPlanInput) {
          sellingPlanInput.value = input && input.value ? input.value : '';
        }
      });
    });

    document.querySelectorAll('.js-gallery-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        switchGalleryImage(thumb);
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return fetchCart();
        })
        .then(renderCartDrawer)
        .then(function () {
          if (!isRechargeCartActive()) {
            openCartDrawer();
          }
        })
        .catch(function () {
          form.submit();
        });
    });

    updateVariantUI();
  }

  function initScrollReveal() {
    var elements = document.querySelectorAll('.story-teaser__polaroid');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function switchGalleryImage(thumb) {
    document.querySelectorAll('.js-gallery-thumb').forEach(function (el) {
      el.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
    var mainImage = document.querySelector('.js-product-main-image');
    if (mainImage) {
      var newSrc = thumb.getAttribute('data-image-src');
      mainImage.src    = newSrc;
      mainImage.srcset = '';
      mainImage.alt    = thumb.getAttribute('data-image-alt') || '';
    }
  }

  function initGallery() {
    document.querySelectorAll('.js-gallery-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        switchGalleryImage(thumb);
      });
    });
  }

  initScrollReveal();
  initGallery();
  initRechargeSubscriptionGiftGuard();
  initProductForm();
  fetchCart().then(function (cart) {
    updateCartCount(cart);
  });

  window.MuaCart = {
    fetchCart: fetchCart,
    renderCartDrawer: renderCartDrawer,
    openCartDrawer: openCart,
    openCart: openCart,
    reconcileSubscriptionGifts: reconcileSubscriptionGifts,
  };
})();
